const m = require('mithril');
const pointTd = require('../../data/components/pointTd');
const mapUtils = require('../mapUtils');

// A mithril component that renders a summary of a child equipment

function routeId(rid) {
  if (!rid && rid !== 0) return '';
  const text = rid.toString();
  return text.startsWith('#') ? text.slice(1) : text;
}

function equipmentUrlFromRid(rid) {
  return `/api/v1/equipment/${routeId(rid)}`;
}

function entityUrl(record) {
  if (mapUtils.isLocationClass(record['@class'])) {
    return `/api/v1/site/${routeId(record['@rid'])}`;
  }
  return equipmentUrlFromRid(record['@rid']);
}

function initialEntityHref(record) {
  if (mapUtils.isLocationClass(record['@class'])) {
    return `/#!/location/${routeId(record['@rid'])}`;
  }
  return `/#!/equipment/${record['@class'].toLowerCase()}/${routeId(record['@rid'])}`;
}

function loadedEntityHref(record) {
  if (mapUtils.isLocationClass(record['@class'])) {
    return `/#!/location/${routeId(record['@rid'])}`;
  }

  const path = Array.isArray(record.path) ? record.path : [];
  const locationAncestorIndex = path.findIndex(ancestor => mapUtils.isLocationClass(ancestor['@class']));
  const topLevelEquipmentInPath = path[locationAncestorIndex - 1] || path[0] || record;
  return `/#!/equipment/${topLevelEquipmentInPath['@class'].toLowerCase()}/${routeId(topLevelEquipmentInPath['@rid'])}`;
}

function datasetHiddenOnMap(dataset) {
  return dataset.hideOnMap === true || dataset.hideOnMap === 'true' || dataset.hideOnMap === 1;
}

function hasPreviewColumns(record) {
  return (record.out_Contains || []).some((containsEdge) => {
    const dataset = containsEdge && containsEdge.in;
    return dataset && !datasetHiddenOnMap(dataset) && Array.isArray(dataset.columns) && dataset.columns.length > 0;
  });
}

function parentEquipmentRid(record) {
  const edge = Array.isArray(record.in_hasComponent) ? record.in_hasComponent[0] : null;
  const parent = edge && edge.out;
  return parent && parent['@rid'] ? parent['@rid'].toString() : null;
}

function parentPreviewRid(record) {
  if (!record || mapUtils.isLocationClass(record['@class']) || hasPreviewColumns(record)) return null;

  const parentRid = parentEquipmentRid(record);
  const recordRid = record['@rid'] ? record['@rid'].toString() : null;
  return parentRid && parentRid !== recordRid ? parentRid : null;
}

function requestPreviewRecord(record, request) {
  const requestFn = request || m.request;
  return requestFn({
    method: 'GET',
    url: entityUrl(record),
  }).then((response) => {
    const parentRid = parentPreviewRid(response);
    if (!parentRid) return response;

    return requestFn({
      method: 'GET',
      url: equipmentUrlFromRid(parentRid),
    }).catch(() => response);
  });
}

class EntityQuickView {
  oninit (vnode) {
    this.entityRecord = vnode.attrs.entityRecord
    this.entityUrl = entityUrl(this.entityRecord);
    this.entityHREF = initialEntityHref(this.entityRecord);
    this.loading = true;
    this.detailLoaded = false;
  }
  oncreate (vnode) {
    this.loading = true;
    this.detailLoaded = false;

    requestPreviewRecord(this.entityRecord).then((response) => {
      this.entityUrl = entityUrl(response);
      this.entityHREF = loadedEntityHref(response);
      this.entityRecord = response;
      this.loading = false;
      this.detailLoaded = true;
    }).catch(() => {
      this.loading = false;
      this.detailLoaded = false;
    });
  }
  view (vnode) {
    const entityRecord = this.entityRecord;
    const entityName = `${entityRecord.name ?? entityRecord['@class']}`;
    const titleContent = this.detailLoaded
      ? m('a.mb2.blue.pointer', {
        href: this.entityHREF,
      }, [
        entityName
      ])
      : m('span.mb2.white', [
        entityName,
        this.loading ? null : m('i.ion-ios-locked.ml2', {
          title: 'No detail access',
          'aria-label': 'No detail access'
        })
      ]);

    return m(`div.bg-dark-gray`, {
      style: {
        width: '18em',
      },
      key: this.entityRecord['@rid'], 
      rid: this.entityRecord['@rid'] 
    }, [
      m('div.ba.bw1.pa2', [
        m('div.mb2', [
          titleContent
        ]),
        (() => {
          if (this.loading) {
            return m('div', 'Loading...');
          }

          if (!this.detailLoaded) return null;

          return (entityRecord.out_Contains || []).map((containsEdge, idx) => {
            let dataset = containsEdge.in;
            if (!dataset) return;
            if (datasetHiddenOnMap(dataset)) return;
            return m(`div.mb2${entityRecord.out_Contains && entityRecord.out_Contains.length ==  idx + 1 ? '' : '.bb.b--blue'}`, [
              dataset.name == 'Default' ? '' : m('div.b1', dataset.name),
              m('table.w-100', {style: {tableLayout: 'fixed'}}, [
                (dataset.columns || []).map(function (column, jdx) {
                  let foundColumn;
                  (dataset.out_Column || []).forEach(columnEdgeRecord => {
                    if (columnEdgeRecord.index == column.id) foundColumn = columnEdgeRecord;
                  })
                  return m('tr', [
                    m(`td.f4.man.tl.moon-gray.w-50${dataset.columns && dataset.columns.length == jdx + 1 ? '' : '.bb'}`, [
                      m('div', column.name)
                    ]),
                    foundColumn ?
                      m(pointTd, {columnRecord: foundColumn, textAlign: 'center'})
                    :
                      m(`td.tc${dataset.columns && dataset.columns.length == jdx + 1 ? '' : '.bb'}`)
                  ])
                })
              ])
            ])
          })
        })(),
      ])
    ])
  }
}

EntityQuickView._private = {
  hasPreviewColumns,
  parentEquipmentRid,
  parentPreviewRid,
  requestPreviewRecord,
};

module.exports = EntityQuickView;
